const getAvatarFallbackColor = (name: string) => {
    const index = name.toUpperCase().charCodeAt(0);
    if (index < 70) return 'bg-yellow-100 text-yellow-900';
    if (index < 75) return 'bg-green-100 text-green-900';
    if (index < 80) return 'bg-red-100 text-red-900';
    if (index < 85) return 'bg-brand-violet-light text-brand-violet-dark';
    if (index < 91) return 'bg-blue-100 text-blue-900';
};

export { getAvatarFallbackColor };
